module.exports = __webpack_public_path__ + "img/tax-report-info.660b5589.svg";